import { render, staticRenderFns } from "./AppContentContainer.vue?vue&type=template&id=23d825d7&"
import script from "./AppContentContainer.vue?vue&type=script&lang=js&"
export * from "./AppContentContainer.vue?vue&type=script&lang=js&"
import style0 from "./AppContentContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports